import { render, staticRenderFns } from "./AlertsDrawer.vue?vue&type=template&id=0a95cad0"
import script from "./AlertsDrawer.vue?vue&type=script&lang=js"
export * from "./AlertsDrawer.vue?vue&type=script&lang=js"
import style0 from "./AlertsDrawer.vue?vue&type=style&index=0&id=0a95cad0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a95cad0')) {
      api.createRecord('0a95cad0', component.options)
    } else {
      api.reload('0a95cad0', component.options)
    }
    module.hot.accept("./AlertsDrawer.vue?vue&type=template&id=0a95cad0", function () {
      api.rerender('0a95cad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AlertsDrawer.vue"
export default component.exports